import { render, staticRenderFns } from "./ProductChangeLog.vue?vue&type=template&id=122e9de7&scoped=true"
import script from "./ProductChangeLog.vue?vue&type=script&lang=js"
export * from "./ProductChangeLog.vue?vue&type=script&lang=js"
import style0 from "./ProductChangeLog.vue?vue&type=style&index=0&id=122e9de7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122e9de7",
  null
  
)

export default component.exports